module.exports = __webpack_public_path__ + "img/wanq.7df25031.png";